import type { BackendRouteDefinition } from '../types';
import { findEmployeeTenantRoute } from './findEmployeeTenant';
import { intakeFormRoutes } from './intakeForm';
import { sharedRoutes } from './shared';

export const routeTable = {
  ...sharedRoutes,
  ...intakeFormRoutes,
  findEmployeeTenant: findEmployeeTenantRoute,
} as const satisfies Record<string, BackendRouteDefinition>;
